import { z } from 'zod';

z.config({
  ...z.locales.de(),

  customError: (issue) => {
    if (issue.code === 'too_small') {
      return 'Erforderlich';
    }

    if (issue.code === 'invalid_format') {
      if (issue.format === 'email') {
        return 'Gültige E-Mail erforderlich (z.B. example@example.com)';
      }

      if (issue.format === 'url') {
        return 'Gültige URL erforderlich (z.B. https://example.com)';
      }
    }

    if (issue.code === 'invalid_type') {
      if (issue.expected === 'string') {
        return 'Erforderlich';
      }

      if (issue.expected === 'number') {
        return 'Erforderlich';
      }
    }

    if (issue.code === 'invalid_value') {
      return 'Erforderlich';
    }

    return issue.message;
  },
});
